// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export var DataStream = function (onMessageDelegate)
{
    if (onMessageDelegate && onMessageDelegate !== null)
        this.OnMessageDelegate = onMessageDelegate;
    else
        this.OnMessageDelegate = null;
}

DataStream.prototype.Dispose = function ()
{

}

DataStream.prototype.Connected = function ()
{

}

DataStream.prototype.SendData = function (message)
{

}
